import { render, staticRenderFns } from "./sharePage.vue?vue&type=template&id=f6f4702a&scoped=true&"
import script from "./sharePage.vue?vue&type=script&lang=js&"
export * from "./sharePage.vue?vue&type=script&lang=js&"
import style0 from "./sharePage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sharePage.vue?vue&type=style&index=1&id=f6f4702a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f4702a",
  null
  
)

export default component.exports